import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context8; _forEachInstanceProperty(_context8 = ownKeys(Object(source), true)).call(_context8, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context9; _forEachInstanceProperty(_context9 = ownKeys(Object(source))).call(_context9, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useCallback, useMemo } from 'react';
import Downshift from '@rexlabs/downshift';
import DownshiftContext from './context';
import { SelectCore } from './core';
import { coerceItemToArray } from './utils';
import { useDownshiftContext } from './hooks';
import { CUSTOM_STATE_CHANGE_TYPES } from './constants';
import { defaultInitialSelectedItems, defaultMultiFilter, defaultMultiItemToString, defaultPluckId, defaultStateReducer } from './defaults';
var DownshiftProvider = DownshiftContext.Provider;
export function MultiSelectCore(_ref) {
  var _ref$pluckId = _ref.pluckId,
      pluckId = _ref$pluckId === void 0 ? defaultPluckId : _ref$pluckId,
      _ref$filter = _filterInstanceProperty(_ref),
      filter = _ref$filter === void 0 ? defaultMultiFilter : _ref$filter,
      value = _ref.value,
      children = _ref.children,
      _ref$initialSelectedI = _ref.initialSelectedItems,
      initialSelectedItems = _ref$initialSelectedI === void 0 ? defaultInitialSelectedItems : _ref$initialSelectedI,
      selectedItems = _ref.selectedItems,
      _ref$itemToString = _ref.itemToString,
      itemToString = _ref$itemToString === void 0 ? defaultMultiItemToString : _ref$itemToString,
      _ref$stateReducer = _ref.stateReducer,
      stateReducer = _ref$stateReducer === void 0 ? defaultStateReducer : _ref$stateReducer,
      props = _objectWithoutProperties(_ref, ["pluckId", "filter", "value", "children", "initialSelectedItems", "selectedItems", "itemToString", "stateReducer"]);

  var stateReducerOverride = useCallback(function (state, changes) {
    var newChanges = changes;

    switch (changes.type) {
      case Downshift.stateChangeTypes.keyDownEnter:
      case Downshift.stateChangeTypes.clickItem:
      case CUSTOM_STATE_CHANGE_TYPES.ADD_FREEFORM_VALUE:
        {
          var _context, _context2, _context3;

          // Either we want to add the selected item if it
          // isn't selected already or remove it if it is
          var selectedItem = _findInstanceProperty(_context = state.selectedItem).call(_context, function (item) {
            return pluckId(item) === pluckId(changes.selectedItem);
          }) ? _filterInstanceProperty(_context2 = state.selectedItem).call(_context2, function (item) {
            return pluckId(item) !== pluckId(changes.selectedItem);
          }) : _concatInstanceProperty(_context3 = []).call(_context3, _toConsumableArray(state.selectedItem), [changes.selectedItem]);
          newChanges = _objectSpread(_objectSpread({}, changes), {}, {
            selectedItem: selectedItem,
            isOpen: true,
            inputValue: itemToString(selectedItem),
            highlightedIndex: state.highlightedIndex
          });
          break;
        }

      case CUSTOM_STATE_CHANGE_TYPES.DELETE_REMOVE:
        {
          var _context4;

          var newSelectedItems = _sliceInstanceProperty(_context4 = state.selectedItem).call(_context4, 0, state.selectedItem.length - 1);

          newChanges = _objectSpread(_objectSpread({}, newChanges), {}, {
            inputValue: itemToString(newSelectedItems),
            selectedItem: newSelectedItems
          });
          break;
        }
    }

    var reducedChanges = stateReducer(state, newChanges); // If we are trying to change the selected item to be
    // anything besides an array force it to be an array instead

    if (reducedChanges.hasOwnProperty('selectedItem')) {
      reducedChanges = _objectSpread(_objectSpread({}, reducedChanges), {}, {
        // TODO: Fix type
        // eslint-disable-next-line
        // @ts-ignore
        selectedItem: coerceItemToArray(reducedChanges.selectedItem)
      });
    }

    return reducedChanges;
  }, [itemToString, pluckId, stateReducer]);
  var validValue = useMemo(function () {
    return value !== undefined ? coerceItemToArray(value) : undefined;
  }, [value]);
  var validSelectedItems = useMemo(function () {
    return selectedItems !== undefined ? coerceItemToArray(selectedItems) : undefined;
  }, [selectedItems]);
  return /*#__PURE__*/React.createElement(SelectCore, _extends({}, props, {
    initialSelectedItem: initialSelectedItems,
    selectedItem: validValue || validSelectedItems,
    filter: filter,
    itemToString: itemToString,
    stateReducer: stateReducerOverride
  }), /*#__PURE__*/React.createElement(MultiSelectInner, null, children));
}

function MultiSelectInner(_ref2) {
  var children = _ref2.children;
  var downshift = useDownshiftContext();
  var selectedItem = downshift.selectedItem,
      setState = downshift.setState;

  var customDownshift = _objectSpread(_objectSpread({}, downshift), {}, {
    selectedItems: selectedItem,
    clearSelectionAtIndex: function clearSelectionAtIndex(index) {
      setState(function (prevState) {
        var _context5, _context6, _context7;

        return _objectSpread(_objectSpread({}, prevState), {}, {
          selectedItem: _concatInstanceProperty(_context5 = []).call(_context5, _toConsumableArray(_sliceInstanceProperty(_context6 = prevState.selectedItem).call(_context6, 0, index)), _toConsumableArray(_sliceInstanceProperty(_context7 = prevState.selectedItem).call(_context7, index + 1, prevState.selectedItem.length))),
          // Fake this type as dowshift doesn't support
          // custom state change types officially
          type: CUSTOM_STATE_CHANGE_TYPES.CLEAR_SELECTION_AT_INDEX
        });
      });
    }
  });

  return /*#__PURE__*/React.createElement(DownshiftProvider, {
    value: customDownshift
  }, children);
}